import { render, staticRenderFns } from "./JcdcFlashConfirm.vue?vue&type=template&id=8c280fd6"
import script from "./JcdcFlashConfirm.vue?vue&type=script&lang=js"
export * from "./JcdcFlashConfirm.vue?vue&type=script&lang=js"
import style0 from "./JcdcFlashConfirm.vue?vue&type=style&index=0&id=8c280fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports